// extracted by mini-css-extract-plugin
module.exports = {"navHeader":"SubcategoryNavigation_navHeader__ScK1A","dropdownHeight":"SubcategoryNavigation_dropdownHeight__ZOyE7","compact":"SubcategoryNavigation_compact__bOyVw"};